import Enumerable from "linq";
import {
  IItem,
  IAlternative,
  instanceOfIAlternative,
} from "../../../domain/document/items";
import { IObjectsAlternatable } from "./IObjectsAlternatable";
import { RangeOfMotionItemAlternator } from "./alternators/RangeOfMotionItemAlternator";
import { Section } from "../../../domain/document";

export class ItemsAlternator {
  private readonly _alternators: IObjectsAlternatable[] = [
    new RangeOfMotionItemAlternator(),
  ];

  public alternate(items: IItem[], sections: Section[]): IItem[] {
    return Enumerable.from(this._alternators)
      .aggregate(items, (s, a) => a.alternate(s, sections));
  }

  public unalternate(items: IItem[]): IItem[] {
    const results = items.concat();
    for (const i of this.extractAlternativeItems(results)) {
      for (const c of i.alternatedContents) {
        results[c.privateId] = c;
      }
    }
    return results;
  }

  private extractAlternativeItems(items: IItem[]): IAlternative[] {
    return Enumerable.from(items)
      .select(i => instanceOfIAlternative(i) ? i as IAlternative : null)
      .where(i => !!i)
      .toArray();
  }
}
